<div>
  <h3>
    {{ label }}
  </h3>
  <div class="checkbox-wrapper">
    @for (option of options | sort: sorting ?? 'alphabetic'; track $index) {
      <markant-checkbox
        class="checkbox"
        [name]="option.label"
        [checked]="selectedOptions.includes(option.key)"
        (checkedChange)="toggleOption(option)"
      >
        {{
          option.isTranslationKey ? (option.label | transloco) : option.label
        }}
      </markant-checkbox>
    }
  </div>
</div>
